export default __webpack_public_path__ + "static/media/right-arrow.f041ca21.svg";